import { createLogic, StandardAction } from "redux-logic";
import {
  POLL_FOR_RX_ORDER,
  FETCH_RX_BOX_MODEL,
  FETCH_ORDER_COMMENTS_FOR_RX_ORDER,
  fetchRxBox,
  setRxBoxModel,
  setRxOrderNumber,
  fetchOrderCommentsForRxOrder,
  setRxOrderComments,
  setRxOrderSku,
  setRxCrateID,
  setRxSortID,
  setRxSortBoxID,
  setRxActionState,
  setRxNextCartShelf,
  POLL_FOR_RX_NEXT_SORTBOX,
  setRxFullCartNumber,
  pollForRxNextSortBox,
  CANCEL_RX_SORT_BOX,
  setRxVerifyOperator,
  SET_RX_ASSISTING_OPERATOR,
  setRxAssistingOperatorState,
  CLEAR_RX_ASSISTING_OPERATOR,
  GET_RX_ASSISTING_OPERATOR,
  FETCH_WARNING_MESSAGES_FOR_RX_ORDER,
  setRxWarningMessages,
  fetchWarningMessagesForRxOrder,
  FETCH_RX_SINGLE_ITEMS,
  setRxSingleItems,
  fetchRxSingleItems,
  FETCH_RX_OPERATOR_INSTRUCTION,
  fetchRxOperatorInstruction,
  setRxInstruction,
  setRxCancelledOrderSku,
  setRxWeightError,
  setRxInputTask,
  setRxNormalTransportCart,
  setRxSingleTransportCart,
  setRxTransportCartRegistrationStarted,
  setLastCartShelf,
  setHasShownRxCheckSubsidyIntruction,
  SIGNALR_MESSAGE_RECEIVED,
  SEND_SCANNED_IPACK_BOX_BARCODE,
  SET_ORDER_INFO,
  FETCH_FULL_ORDER,
  fetchFullOrder,
  setOrderInfo,
  updateSortBoxItemQuantity,
  updateOrderInfo,
  SEND_LOGIN_INFO,
  SET_STATION_PAUSED,
  sendLoginInfo,
  SET_CURRENT_BOX_SNOOZED,
  SEND_BOX_CANCELLATION,
  setBoxCancelled,
  UPDATE_ORDER_INFO,
  SET_SORT_BOX_ITEM_QUANTITY,
  setLastActionTimestamp,
  SET_MAXX_MODE,
  setMaxxMode,
  SEND_MAXX_ORDER_FINISHED,
  GET_TEAMLEADER_AVAILABILITY,
  setTeamleaderAvailability,
  SEND_FLUSH_QUEUE_REQUEST,
  setCancelleationReasonMessageShown,
  SET_RX_BOX_MODEL,
  setSkuPutawayBoxID,
  SET_SKU_PUTAWAY_BIN_SHELFNUMBER,
  setRxInstructionMessage,
  PERFORM_SKU_PUTAWAY_MISSING_QUANTITY,
  setSkuPutawayBinShelfNumber,
  setSkuPutawayErrorMessage,
  setSkuPutawayBoxItem,
  setRxMissingAmountDialogSortBoxItem,
  setWaitingForEjectBox,
  SET_RX_AUTO_ORDER_DONE,
  setRxAutoOrderDone,
  BOX_NOTIFICATION,
  boxNotification,
  SET_WAREHOUSE_ALARM,
} from "../reducers/rxBoxModeReducer";
import RxEndpoints from "../../rxMode/rxModeEndpoints";
import { IPayloadWrapper, PayloadWrapper } from "../types/PayloadWrapper";
import { ISortBoxModel } from "../../sortbox/ISortBoxModel";
import { IRxComment } from "../../rxMode/IRxComment";
import RxBox from "../../rxMode/rxBox";
import {
  setError,
  setLoadingStatus,
  setShouldRedirect,
  setShowLoader,
} from "../reducers/applicationStateReducer";
import { setCartID, setSortID } from "../reducers/cartReducer";
import { ActionStates } from "../../rxMode/ActionStates";
import SortBoxEndpoints from "../../sortbox/SortBoxEndpoints";
import RXWestEndpoints from "../../rxMode/rxWestEndpoints";
import IPackEndpoints from "../../ipack/IPackEndpoints";
import { DispatchType, IRxBoxAppState } from "../../rxMode/IRxBoxAppState";
import { IRxAssistantOperator } from "../../rxMode/IRxAssistantOperator";
import { setRxSingleListButtonHeight, setRxWarningHeight } from "../reducers/layoutHelperReducer";
import SinglesEndpoints from "../../singles/SinglesEndpoints";
import { ISingleSortBoxItemModel, ISortBoxItemModel } from "../../SortBoxItem/ISortBoxItemModel";
import SharedFunctions from "../../../utils/SharedFunctions";
import OperatorEndpoints from "../../operator/OperatorEndpoints";
import { IOperatorInstructionModel } from "../../../typewriterModels/IOperatorInstructionModel";
import { LimaOperatorTask } from "../../lima/LimaOperatorTask";
import rxModeEndpoints from "../../rxMode/rxModeEndpoints";
import { LoginState } from "../types/LoginStateTypes";
import { IPackCancelledWorkstationType } from "../../ipack/IPackCancelledWorkstationType";
import {
  IBoxCancellationRequest,
  IBoxNotification,
  IOrderInfo,
  IOrderInfoRequest,
  IPurgeRequest,
  IRXOperatorInfoModel,
  IRxSortBoxInfo,
  IRxSortBoxItemUpdate,
  ISnoozeRequest,
  MessageType,
} from "../../rxAutoMessages/rxAutoMessages";
import { setLoginStatus } from "../reducers/applicationStateReducer";
import rxWestEndpoints from "../../rxMode/rxWestEndpoints";
import { ArgumentAction } from "redux-logic/definitions/action";
import { ApplicationState } from "../types/ApplicationStateTypes";

const REGISTER_TRANSPORTCART_INSTRUCTION_ERROR_ID = 998;
const REGISTER_TRANSPORTCART_INSTRUCTION_ID = 998;
const CHECK_SUBSIDY_INSTRUCTION_ID = 990;

const pollForRxOrderLogic = createLogic({
  type: POLL_FOR_RX_ORDER,
  async process(
    {
      getState,
    }: {
      getState: any;
    },
    dispatch,
    done
  ) {
    const { operatorID, workstationID } = getState().loginInfoReducer;
    await RxEndpoints.pollForOrder(operatorID, workstationID)
      .then((rxOrderNumber) => {
        const { rxOrderSku } = getState().rxModeReducer as IRxBoxAppState;
        if (rxOrderSku !== rxOrderNumber) {
          dispatch(setRxTransportCartRegistrationStarted(new PayloadWrapper(false)));
          dispatch(setRxWeightError(new PayloadWrapper("")));
          dispatch(setRxCancelledOrderSku(new PayloadWrapper(-1)));
          dispatch(setLoadingStatus(new PayloadWrapper(true)));
          const payload = new PayloadWrapper(rxOrderNumber);
          dispatch(setRxOrderSku(payload));
          dispatch(fetchRxBox(payload));
          dispatch(fetchRxOperatorInstruction());
        }
      })
      .catch((error) => {
        //handle error
      });
    done();
  },
});

const rxSignalRMessageReceiverLogic = createLogic({
  type: SIGNALR_MESSAGE_RECEIVED,
  async process({ getState, action }: { getState: any; action: any }, dispatch, done) {
    const appState: ApplicationState = getState().applicationStateReducer;
    const rxState: IRxBoxAppState = getState().rxModeReducer;
    const type: MessageType = action.payload.Type;
    const loginState: LoginState = getState().loginInfoReducer;
    if (appState.loggedIn && loginState.operatorID > 0) {
      switch (type) {
        case MessageType.LRXItemUpdate:
          dispatch(updateSortBoxItemQuantity(action.payload));
          break;
        case MessageType.LRXOrderInfo:
          const payloadOrderInfo = action.payload.OrderInfo as IOrderInfo;
          if (
            rxState.orderInfo &&
            payloadOrderInfo &&
            rxState.orderInfo.SortBoxID > 0 &&
            rxState.orderInfo.SortBoxID === payloadOrderInfo.SortBoxID
          ) {
            var putawayStateChanged =
              payloadOrderInfo.SkuPutawayRequired &&
              rxState.orderInfo.SkuPutawayRequired !== payloadOrderInfo.SkuPutawayRequired;
            dispatch(updateOrderInfo(payloadOrderInfo));
            if (putawayStateChanged) {
              //hämta alltid uppdaterad/senaste verified quantity så att lagerinläsning sker korrekt
              dispatch(fetchFullOrder(new PayloadWrapper(payloadOrderInfo.SortBoxID)));
            }
            if (
              payloadOrderInfo.SkuPutawayRequired == false &&
              payloadOrderInfo.SortBoxes.every((x: IRxSortBoxInfo) => x.Done || x.Cancelled)
            ) {
              //dispatch(fetchFullOrder(new PayloadWrapper(payloadOrderInfo.SortBoxID)));
              dispatch(setRxAutoOrderDone());
            } else {
              dispatch(setWaitingForEjectBox(new PayloadWrapper(false)));
            }
          } else {
            dispatch(setOrderInfo(payloadOrderInfo));
          }
          break;
        case MessageType.LRXOrderFinished:
          console.log(action.payload);
          break;
        case MessageType.BoxNotification:
          dispatch(boxNotification(action.payload));
          console.log(action.payload);
          break;
        default:
          console.log("unknown message type");
          console.log(action.payload);
          break;
      }
    }
    done();
  },
});

const boxNotificationLogic = createLogic({
  type: BOX_NOTIFICATION,
  async process(
    { action, getState }: { action: StandardAction<string, IBoxNotification>; getState: any },
    dispatch,
    done
  ) {
    const rxState: IRxBoxAppState = getState().rxModeReducer;
    const loginState: LoginState = getState().loginInfoReducer;
    const appState: ApplicationState = getState().applicationStateReducer;

    if (appState.shouldRedirect) {
      if (
        rxState.orderInfo === null ||
        rxState.orderInfo.NonRXOrder ||
        rxState.orderInfo.NotFound ||
        !action.payload.Queued
      ) {
        dispatch(setShouldRedirect(new PayloadWrapper(false)));
        const loginInfo: IRXOperatorInfoModel = {
          WorkstationID: loginState.workstationID,
          OperatorID: -1,
          LRX: false,
          LoggedIn: false,
          Paused: false,
          LoopTeamleader: false,
        };
        dispatch(sendLoginInfo(loginInfo));
        dispatch(setLoginStatus(new PayloadWrapper(false)));
      }
    }
    done();
  },
});

const setTimeStampLogic = createLogic({
  type: [SET_ORDER_INFO, UPDATE_ORDER_INFO, SET_SORT_BOX_ITEM_QUANTITY, SEND_LOGIN_INFO],
  async process({}: {}, dispatch, done) {
    dispatch(setLastActionTimestamp(new PayloadWrapper(Date.now())));
    done();
  },
});

const sendSortBoxSnoozed = createLogic({
  type: SET_CURRENT_BOX_SNOOZED,
  async process({ getState }: { getState: any }, _, done) {
    const rxState: IRxBoxAppState = getState().rxModeReducer;
    const orderInfo: IOrderInfo | null = rxState.orderInfo;
    const loginState: LoginState = getState().loginInfoReducer;

    if (orderInfo !== null) {
      const CurrentSortBoxID = orderInfo.CurrentSortBoxID;
      const workstationID = loginState.workstationID;
      if (CurrentSortBoxID > 0) {
        const snoozeReq: ISnoozeRequest = {
          WorkstationID: workstationID,
          RXSortBoxID: CurrentSortBoxID,
        };
        await RXWestEndpoints.sendSortBoxSnooze(snoozeReq)
          .then(() => console.log("sent snooze"))
          .catch((e) => console.log(e))
          .finally(() => done());
      } else {
        done();
      }
    }
  },
});

const sendFlushQueueRequest = createLogic({
  type: SEND_FLUSH_QUEUE_REQUEST,
  async process({ action }: { action: StandardAction<string, IPurgeRequest> }, dispatch, done) {
    dispatch(setLoadingStatus(new PayloadWrapper(true)));
    rxWestEndpoints.sendFlushQueueRequest(action.payload).finally(() => {
      dispatch(setLoadingStatus(new PayloadWrapper(false)));
      done();
    });
  },
});

const setRxAutoOrderDoneLogic = createLogic({
  type: SET_RX_AUTO_ORDER_DONE,
  async process(
    {
      getState,
    }: {
      getState: any;
    },
    dispatch,
    done
  ) {
    const appState: ApplicationState = getState().applicationStateReducer;
    const rxState: IRxBoxAppState = getState().rxModeReducer;
    const orderInfo: IOrderInfo | null = rxState.orderInfo;
    const loginState: LoginState = getState().loginInfoReducer;
    if (!orderInfo || loginState.operatorID === -1 || !appState.loggedIn) {
      done();
      return;
    }
    const sortBoxID = orderInfo?.SortBoxID;
    const workstationID = loginState.workstationID;
    await RXWestEndpoints.handleRxOrderFinished(sortBoxID, workstationID)
      .then((result) => {
        dispatch(setWaitingForEjectBox(new PayloadWrapper(true)));
      })
      .catch((error) => {
        dispatch(
          setError({
            message: "Kunde inte skicka att order färdig: " + error,
            visible: true,
            errorType: -1,
          })
        );
      })
      .finally(done);
  },
});

const sendPrintRXBodIDLogic = createLogic({
  type: SET_MAXX_MODE,
  async process(
    {
      getState,
      action,
    }: { getState: any; action: StandardAction<string, IPayloadWrapper<boolean>> },
    dispatch,
    done
  ) {
    const rxState: IRxBoxAppState = getState().rxModeReducer;
    const orderInfo: IOrderInfo | null = rxState.orderInfo;
    const loginState: LoginState = getState().loginInfoReducer;

    if (orderInfo !== null && orderInfo.CurrentSortBoxID > 0 && action.payload.value) {
      const CurrentSortBoxID = orderInfo.CurrentSortBoxID;
      const workstationID = loginState.workstationID;
      rxModeEndpoints
        .printRXBoxID(CurrentSortBoxID, workstationID)
        .then((res) => {
          if (!res.success) {
            dispatch(
              setError({
                message: res.reason,
                visible: true,
                errorType: -1,
              })
            );
          }
        })
        .catch((e) => console.log(e))
        .finally(() => done());
    } else {
      done();
    }
  },
});

const performSkuPutawayMissingLogic = createLogic({
  type: PERFORM_SKU_PUTAWAY_MISSING_QUANTITY,
  async process(
    {
      getState,
      action,
    }: { getState: any; action: StandardAction<string, IPayloadWrapper<number>> },
    dispatch,
    done
  ) {
    await performSkuPutaway(getState, dispatch, done, "", action.payload.value);
  },
});

const performSkuPutawayLogic = createLogic({
  type: SET_SKU_PUTAWAY_BIN_SHELFNUMBER,
  async process(
    {
      getState,
      action,
    }: { getState: any; action: StandardAction<string, IPayloadWrapper<string | null>> },
    dispatch,
    done
  ) {
    if (action.payload.value) {
      await performSkuPutaway(getState, dispatch, done, action.payload.value, 0).finally(done);
    } else done();
  },
});

const sendMaxxOrderFinishedLogic = createLogic({
  type: SEND_MAXX_ORDER_FINISHED,
  async process({ getState }: { getState: any }, dispatch, done) {
    const rxState: IRxBoxAppState = getState().rxModeReducer;
    const loginState: LoginState = getState().loginInfoReducer;

    if (rxState.orderInfo !== null && rxState.orderInfo.CurrentSortBoxID > 0) {
      const CurrentSortBoxID = rxState.orderInfo.CurrentSortBoxID;
      const workstationID = loginState.workstationID;
      dispatch(setLoadingStatus(new PayloadWrapper(true)));
      RXWestEndpoints.sendMaxxOrderFinished(CurrentSortBoxID, workstationID)
        .then(() => console.log("sent order finished"))
        .catch((e) => {
          console.log(e);
          dispatch(
            setError({
              message: "Fel vid expediering",
              visible: true,
              errorType: -1,
            })
          );
        })
        .finally(() => {
          dispatch(setMaxxMode(new PayloadWrapper(false)));
          dispatch(setLoadingStatus(new PayloadWrapper(false)));
          done();
        });
    } else {
      done();
    }
  },
});

const getTeamleaderAvailabilityLogic = createLogic({
  type: GET_TEAMLEADER_AVAILABILITY,
  async process({ getState }: { getState: any }, dispatch, done) {
    const loginState: LoginState = getState().loginInfoReducer;
    const workstationID = loginState.workstationID;
    const rxState: IRxBoxAppState = getState().rxModeReducer;

    if (rxState.loopTeamleader) {
      dispatch(setTeamleaderAvailability(new PayloadWrapper(false)));
      done();
      return;
    }

    await rxWestEndpoints
      .getTeamleaderAvailability(workstationID)
      .then((available: boolean) => {
        dispatch(setTeamleaderAvailability(new PayloadWrapper(available)));
      })
      .catch((_) => {
        dispatch(setTeamleaderAvailability(new PayloadWrapper(false)));
      })
      .finally(() => {
        done();
      });
  },
});

const sendBoxCancellation = createLogic({
  type: SEND_BOX_CANCELLATION,
  async process(
    { action }: { getState: any; action: StandardAction<string, IBoxCancellationRequest> },
    dispatch,
    done
  ) {
    dispatch(setLoadingStatus(new PayloadWrapper(true)));
    await RXWestEndpoints.sendBoxCancellation(action.payload)
      .then((result) => {
        if (result === true) {
          dispatch(setBoxCancelled(new PayloadWrapper(true)));
          dispatch(setWaitingForEjectBox(new PayloadWrapper(true)));
        } else {
          dispatch(
            setError({
              message: "Kunde inte avbryta ordern. Försök igen",
              visible: true,
              errorType: -1,
            })
          );
        }
      })
      .catch((e) => {
        dispatch(
          setError({
            message: "Kunde inte avbryta ordern. Försök igen",
            visible: true,
            errorType: -1,
          })
        );
      })
      .finally(() => {
        dispatch(setLoadingStatus(new PayloadWrapper(false)));
      });

    done();
  },
});

const sendStationPausedLogic = createLogic({
  type: SET_STATION_PAUSED,
  async process({ getState }: { getState: any }, dispatch, done) {
    const rxState: IRxBoxAppState = getState().rxModeReducer;
    const loginState: LoginState = getState().loginInfoReducer;
    const loginInfo: IRXOperatorInfoModel = {
      OperatorID: loginState.operatorID,
      WorkstationID: loginState.workstationID,
      LoggedIn: true,
      LRX: false,
      Paused: rxState.stationPaused,
      LoopTeamleader: rxState.loopTeamleader,
    };
    dispatch(sendLoginInfo(loginInfo));
    done();
  },
});

const sendLoginInfoLogic = createLogic({
  type: SEND_LOGIN_INFO,
  async process(
    { action }: { action: StandardAction<string, IRXOperatorInfoModel> },
    dispatch,
    done
  ) {
    await RXWestEndpoints.sendLoginInfo(action.payload)
      .then(() => console.log(action.payload))
      .catch((e) => {
        console.log(e);
        if (action.payload.LoggedIn) {
          dispatch(setLoginStatus(new PayloadWrapper(false)));
        }
      })
      .finally(() => done());
  },
});

export const setRxBoxLogic = createLogic({
  type: SET_RX_BOX_MODEL,
  async process(
    {
      getState,
      action,
    }: { getState: any; action: StandardAction<string, IPayloadWrapper<ISortBoxModel | null>> },
    dispatch,
    done
  ) {
    //todo fix when cancel bag is implemented
    const { orderInfo } = getState().rxModeReducer as IRxBoxAppState;
    if (action.payload.value != null && orderInfo?.SkuPutawayRequired === true) {
      var putawayDone = !action.payload.value.sortBoxItems?.some(
        (x) =>
          orderInfo?.SortBoxes.some((z) => z.Done && z.SortBoxID === x.boxID) == true &&
          x.reservedQuantity != x.verifiedQuantity
      );
      if (putawayDone) dispatch(fetchFullOrder(new PayloadWrapper(orderInfo.SortBoxID))); // TODO call last when implementing cancel bag
      //     orderInfo?.SortBoxes.filter(x=> x.Cancelled).forEach(element => {
      //       await  SortBoxEndpoints.deleteSortBoxAndRxChildren(element.SortBoxID)
      //       .then(() => {

      //       })
      //       .catch((e) => {
      //         dispatch(
      //           setError({
      //             message: "Kunde inte stryka plocklista:" + e,
      //             visible: true,
      //             errorType: -1,
      //           })
      //         );
      //       })
      //       .finally(() => {
      //         done();
      //       });

      //   }
    }
    done();
  },
});

const setOrderInfoLogic = createLogic({
  type: SET_ORDER_INFO,
  async process({ action }: { action: StandardAction<string, IOrderInfo> }, dispatch, done) {
    const orderInfo: IOrderInfo | null = action.payload;
    clearCurrentRXOrder(dispatch);

    if (orderInfo && orderInfo.SortBoxID > 0) {
      dispatch(fetchFullOrder(new PayloadWrapper(action.payload.SortBoxID)));
    } else {
      if (orderInfo && orderInfo.NotFound) {
        dispatch(
          setError({
            message: "Kunde inte ladda order",
            visible: true,
            errorType: -1,
          })
        );
      }
    }
    done();
  },
});

const fetchFullOrderLogic = createLogic({
  type: FETCH_FULL_ORDER,
  async process(
    {
      action,
      getState,
    }: { action: StandardAction<string, IPayloadWrapper<number>>; getState: any },
    dispatch,
    done
  ) {
    dispatch(setLoadingStatus(new PayloadWrapper(true)));
    const { orderInfo } = getState().rxModeReducer as IRxBoxAppState;
    await SortBoxEndpoints.getFullOrderRX(action.payload.value)
      .then(async (result: ISortBoxModel) => {
        if (orderInfo?.SkuPutawayRequired == true) {
          var anyItemsToPutaway = result?.sortBoxItems?.some(
            (x) =>
              x.reservedQuantity > x.verifiedQuantity &&
              orderInfo?.SortBoxes.some((p) => p.Done && p.SortBoxID === x.boxID)
          );
          if (anyItemsToPutaway) {
            const currentSkuPutawayRXSortboxID = result?.sortBoxItems.filter(
              (r) =>
                r.boxID !== result?.sortBoxID &&
                r.verifiedQuantity < r.reservedQuantity &&
                orderInfo?.SortBoxes.some((p) => p.Done && p.SortBoxID === r.boxID)
            )[0]?.boxID;
            if (currentSkuPutawayRXSortboxID > 0) {
              result?.sortBoxItems
                .filter((x) => x.boxID === currentSkuPutawayRXSortboxID)
                .forEach((x: ISortBoxItemModel) => {
                  //prepare each item for stockPutaway
                  x.reservedQuantity = x.reservedQuantity - x.verifiedQuantity;
                  x.verifiedQuantity = 0;
                });
              dispatch(setSkuPutawayBoxID(new PayloadWrapper(currentSkuPutawayRXSortboxID)));
            }
          } else {
            var allBoxesDoneOrCancelled = orderInfo?.SortBoxes.every((p) => p.Done);
            dispatch(setSkuPutawayBoxID(new PayloadWrapper(null)));
            if (allBoxesDoneOrCancelled && orderInfo?.ReleaseBox == false)
              dispatch(setRxAutoOrderDone());
            var orderInfoNew = {
              ...orderInfo,
              SkuPutawayRequired: false,
              ReleaseBox: true,
              OrderDoneSent: true,
            };
            dispatch(setOrderInfo(orderInfoNew));
          }
        } else if (orderInfo?.ReleaseBox && !orderInfo?.OrderDoneSent) {
          dispatch(setRxAutoOrderDone());
        }
        else {
          dispatch(setWaitingForEjectBox(new PayloadWrapper(false)));
        } 
        console.log(result);
        dispatch(setRxBoxModel(new PayloadWrapper(result)));
        dispatch(setLoadingStatus(new PayloadWrapper(false)));
      })
      .catch((e) => {
        dispatch(setLoadingStatus(new PayloadWrapper(false)));
        console.log(e);
      })
      .finally(() => done());
  },
});

const sendScannedIPackBoxbarcodeLogic = createLogic({
  type: SEND_SCANNED_IPACK_BOX_BARCODE,
  async process({ getState, action }: { getState: any; action: any }, dispatch, done) {
    console.log(getState());
    const orderInfoRequest: IOrderInfoRequest = {
      IPackBoxBarcode: action.payload.value,
      WorkstationID: getState().loginInfoReducer.workstationID,
    };
    dispatch(setLoadingStatus(new PayloadWrapper(true)));
    await RXWestEndpoints.sendScannedIPackBoxBarcode(orderInfoRequest)
      .then((result) => {
        console.log(result);
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        dispatch(setLoadingStatus(new PayloadWrapper(false)));
      });
    done();
  },
});

const pollForRxNextSortBoxLogic = createLogic({
  type: POLL_FOR_RX_NEXT_SORTBOX,
  async process(
    {
      getState,
    }: {
      getState: any;
    },
    dispatch,
    done
  ) {
    const { currentInstruction, rxSortBox, fullCartNumber, lastCartShelf } = getState()
      .rxModeReducer as IRxBoxAppState;
    if (fullCartNumber === -1) {
      done();
      return;
    }
    const lastInstructionID = currentInstruction ? currentInstruction.id : -1;
    await SortBoxEndpoints.getNextSortBox(
      fullCartNumber.toString(),
      rxSortBox,
      "",
      -1,
      -1,
      lastInstructionID
    )
      .then((sb) => {
        if (sb.notFound) {
          dispatch(setRxNextCartShelf(new PayloadWrapper(-1)));
          setStateWaitingForShelfScan(dispatch, ActionStates.SET_CART);
        } else {
          const { sortBoxModel, cancelledRxOrderSku, rxModeAction } = getState()
            .rxModeReducer as IRxBoxAppState;
          if (
            rxModeAction === ActionStates.SCAN_SHELF_OR_CART &&
            ((sortBoxModel?.sortBoxItems &&
              !sortBoxModel?.sortBoxItems?.some(
                (x: { verifiedQuantity: number }) => x.verifiedQuantity === 0
              )) ||
              sortBoxModel?.invoiceNumber !== -1 ||
              cancelledRxOrderSku === sortBoxModel.rxOrderSkuId)
          ) {
            if (
              sb.shelfNumber !== lastCartShelf &&
              rxModeAction !== ActionStates.SCAN_SHELF_OR_CART
            ) {
              setStateWaitingForShelfScan(dispatch, ActionStates.SCAN_SHELF_OR_CART);
            } else if (lastCartShelf === 1 || lastCartShelf === 51) {
              setStateWaitingForShelfScan(dispatch, ActionStates.SCAN_SINGLE_ARTICLE);
            }
          }
          dispatch(setRxNextCartShelf(new PayloadWrapper(sb.shelfNumber)));
        }
        dispatch(setLoadingStatus(new PayloadWrapper(false)));
      })
      .catch((error) => {
        //TODO
        console.log(error);
      });

    done();
  },
});

function setStateWaitingForShelfScan(dispatch: DispatchType, newState: ActionStates) {
  dispatch(setRxBoxModel(new PayloadWrapper({} as ISortBoxModel)));
  dispatch(setRxOrderComments([]));
  dispatch(setRxWarningMessages(new PayloadWrapper([])));
  dispatch(setRxActionState(new PayloadWrapper(newState)));
  dispatch(setLoadingStatus(new PayloadWrapper(false)));
  dispatch(setRxSingleListButtonHeight(new PayloadWrapper(0)));
  dispatch(setRxWarningHeight(new PayloadWrapper(0)));
  dispatch(setHasShownRxCheckSubsidyIntruction(new PayloadWrapper(false)));
}

function clearCurrentRXOrder(dispatch: any) {
  dispatch(setBoxCancelled(new PayloadWrapper(false)));
  dispatch(setRxBoxModel(new PayloadWrapper(null)));
  dispatch(setLoadingStatus(new PayloadWrapper(false)));
  dispatch(setCancelleationReasonMessageShown(new PayloadWrapper(false)));
}

const fetchRxBoxLogic = createLogic({
  type: FETCH_RX_BOX_MODEL,
  async process({ getState }: { getState: any }, dispatch, done) {
    await RxEndpoints.fetchRxBox()
      .then(async (sortBoxModel: ISortBoxModel) => {
        if (sortBoxModel?.sortBoxID) {
          sortBoxModel.sortBoxItems = sortboxItemsByNameAsc(sortBoxModel.sortBoxItems);
          const rxBox = new RxBox(sortBoxModel);
          const {
            rxModeAction,
            rxSortBox,
            cancelledRxOrderSku,
            singleTransportCart,
            normalTransportCart,
            currentInstruction,
            inputTask,
            transportCartRegistrationStarted,
            hasShownCheckRxSubsidyInstruction,
            orderInfo,
          } = getState().rxModeReducer as IRxBoxAppState;

          if (rxModeAction === ActionStates.COMPLETE_BOX)
            if (orderInfo?.SkuPutawayRequired == true) {
              rxBox.rxSortBoxModel.sortBoxItems.forEach((x: ISortBoxItemModel) => {
                //prepare each item for stockPutaway
                x.reservedQuantity = x.reservedQuantity - x.verifiedQuantity;
                x.verifiedQuantity = 0;
              });
            }
          dispatch(setRxBoxModel(new PayloadWrapper(rxBox.rxSortBoxModel)));
          if (
            rxSortBox !== sortBoxModel.sortBoxID &&
            cancelledRxOrderSku !== sortBoxModel.rxOrderSkuId
          ) {
            dispatch(setRxSingleListButtonHeight(new PayloadWrapper(0)));
            dispatch(setRxWarningHeight(new PayloadWrapper(0)));
            dispatch(setRxOrderNumber(new PayloadWrapper(sortBoxModel.orderNumber)));
            dispatch(setRxCrateID(new PayloadWrapper(sortBoxModel.cartID)));
            dispatch(setRxFullCartNumber(new PayloadWrapper(sortBoxModel.fullCartNumber)));
            dispatch(setRxSortID(new PayloadWrapper(sortBoxModel.sortID)));
            dispatch(setRxSortBoxID(new PayloadWrapper(sortBoxModel.sortBoxID)));
            dispatch(setRxOrderSku(new PayloadWrapper(sortBoxModel.rxOrderSkuId)));
            dispatch(setSortID(new PayloadWrapper(sortBoxModel.sortID)));
            dispatch(setCartID(new PayloadWrapper(sortBoxModel.cartID)));
            dispatch(setLastCartShelf(new PayloadWrapper(sortBoxModel.shelfNumber)));
            dispatch(fetchOrderCommentsForRxOrder());
            dispatch(fetchWarningMessagesForRxOrder());
            dispatch(fetchRxSingleItems());
            dispatch(pollForRxNextSortBox());
          }
          if (
            sortBoxModel.invoiceNumber === -1 &&
            cancelledRxOrderSku !== sortBoxModel.rxOrderSkuId
          ) {
            dispatch(setRxActionState(new PayloadWrapper(ActionStates.COMPLETE_BOX)));
          } else if (
            sortBoxModel.invoiceNumber > -1 &&
            sortBoxModel.forceNormalWorkstation !== IPackCancelledWorkstationType.Paused
          ) {
            const { branchID, operatorID } = getState().loginInfoReducer as LoginState;
            if (
              !transportCartRegistrationStarted &&
              branchID === 10 &&
              sortBoxModel.rxDeliveryBranch !== 10 &&
              ((sortBoxModel.isRxSingle && !singleTransportCart) ||
                (!sortBoxModel.isRxSingle && !normalTransportCart))
            ) {
              if (!registerTransportCartInstructionShown(currentInstruction, inputTask)) {
                if (!sortBoxModel.isRxSingle && !normalTransportCart) {
                  showScanTransportCartInstruction(
                    "Registrera transportback för att fortsätta.",
                    REGISTER_TRANSPORTCART_INSTRUCTION_ID,
                    sortBoxModel.isRxSingle,
                    dispatch
                  );
                } else if (!singleTransportCart) {
                  showScanTransportCartInstruction(
                    "Registrera singeltransportback för att fortsätta.",
                    REGISTER_TRANSPORTCART_INSTRUCTION_ID,
                    sortBoxModel.isRxSingle,
                    dispatch
                  );
                }
              }
            } else {
              if (
                branchID === 10 &&
                sortBoxModel.rxDeliveryBranch !== 10 &&
                (singleTransportCart || normalTransportCart)
              ) {
                if (!transportCartRegistrationStarted) {
                  await registerTransportCart(
                    dispatch,
                    sortBoxModel,
                    singleTransportCart,
                    normalTransportCart,
                    operatorID,
                    currentInstruction
                  );
                }
              } else {
                setWaitingForNextOrder(sortBoxModel, dispatch);
              }
            }
          } else if (
            !hasShownCheckRxSubsidyInstruction &&
            sortBoxModel.forceNormalWorkstation === IPackCancelledWorkstationType.Paused &&
            currentInstruction?.id !== CHECK_SUBSIDY_INSTRUCTION_ID
          ) {
            dispatch(setHasShownRxCheckSubsidyIntruction(new PayloadWrapper(true)));
            dispatch(
              setRxInstruction({
                desiredWorkstationId: -1,
                desiredSortId: -1,
                desiredTask: LimaOperatorTask.CheckRxSubsidy,
                message:
                  "Kontrollera subventionen för denna order. Pristillägg och förmånstyp måste stämma. Rätta till dessa.",
                id: CHECK_SUBSIDY_INSTRUCTION_ID,
                desiredCartId: -1,
                visible: true,
              })
            );
          }
        } else {
          dispatch(setRxNextCartShelf(new PayloadWrapper(-1)));
          setStateWaitingForShelfScan(dispatch, ActionStates.SCAN_SHELF_OR_CART);
        }
      })
      .catch((error) => {
        //handle error
      });

    done();
  },
});

function registerTransportCartInstructionShown(
  currentInstruction: IOperatorInstructionModel | null,
  inputTask: LimaOperatorTask
) {
  return (
    currentInstruction?.id === REGISTER_TRANSPORTCART_INSTRUCTION_ERROR_ID ||
    inputTask === LimaOperatorTask.RegisterNormalTransportCart ||
    inputTask === LimaOperatorTask.RegisterSingleTransportCart
  );
}

async function registerTransportCart(
  dispatch: any,
  sortBoxModel: ISortBoxModel,
  singleTransportCart: string | null,
  normalTransportCart: string | null,
  operatorID: number,
  currentInstruction: IOperatorInstructionModel | null
) {
  dispatch(setRxTransportCartRegistrationStarted(new PayloadWrapper(true)));
  var transportCartToRegister = sortBoxModel.isRxSingle ? singleTransportCart : normalTransportCart;
  if (!transportCartToRegister) return;
  dispatch(setShowLoader(new PayloadWrapper(true)));
  return rxModeEndpoints
    .registerTransportCartForOrder(
      operatorID,
      sortBoxModel.rxOrderSkuId as number,
      transportCartToRegister,
      sortBoxModel.isRxSingle
    )
    .then(() => {
      dispatch(setShowLoader(new PayloadWrapper(false)));
      setWaitingForNextOrder(sortBoxModel, dispatch);
    })
    .catch((ex) => {
      dispatch(setShowLoader(new PayloadWrapper(false)));
      dispatch(setRxTransportCartRegistrationStarted(new PayloadWrapper(false)));
      if (
        currentInstruction === null ||
        currentInstruction.id !== REGISTER_TRANSPORTCART_INSTRUCTION_ERROR_ID
      ) {
        if (sortBoxModel.isRxSingle) {
          showScanTransportCartInstruction(
            ex?.message + " Scanna singeltransportback på nytt för att fortsätta.",
            REGISTER_TRANSPORTCART_INSTRUCTION_ERROR_ID,
            true,
            dispatch
          );
        } else {
          showScanTransportCartInstruction(
            ex?.message + " Scanna transportback på nytt för att fortsätta.",
            REGISTER_TRANSPORTCART_INSTRUCTION_ERROR_ID,
            false,
            dispatch
          );
        }
      }
    });
}

function showScanTransportCartInstruction(
  instructionMessage: string,
  instructionId: number,
  isRxSingle: boolean,
  dispatch: any
) {
  if (isRxSingle) dispatch(setRxSingleTransportCart(new PayloadWrapper(null)));
  else dispatch(setRxNormalTransportCart(new PayloadWrapper(null)));
  dispatch(
    setRxInstruction({
      desiredWorkstationId: -1,
      desiredSortId: -1,
      desiredTask: isRxSingle
        ? LimaOperatorTask.RegisterSingleTransportCart
        : LimaOperatorTask.RegisterNormalTransportCart,
      message: instructionMessage,
      id: instructionId,
      desiredCartId: -1,
      visible: true,
    })
  );
  dispatch(
    setRxInputTask(
      new PayloadWrapper(
        isRxSingle
          ? LimaOperatorTask.RegisterSingleTransportCart
          : LimaOperatorTask.RegisterNormalTransportCart
      )
    )
  );
}

function setWaitingForNextOrder(sortBoxModel: ISortBoxModel, dispatch: any) {
  setStateWaitingForShelfScan(dispatch, ActionStates.SCAN_SHELF_OR_CART);
  if (sortBoxModel.sortType === 1 || sortBoxModel?.shelfNumber === 51) {
    dispatch(fetchRxSingleItems());
  }
  dispatch(pollForRxNextSortBox());
  dispatch(fetchRxOperatorInstruction());
}

const fetchRxSingleItemsLogic = createLogic({
  type: FETCH_RX_SINGLE_ITEMS,
  async process({ getState }: { getState: any }, dispatch, done) {
    const { fullCartNumber, crateID } = getState().rxModeReducer as IRxBoxAppState;
    if (crateID > 0) {
      await SinglesEndpoints.loadSingleItems(fullCartNumber)
        .then((singleItems: ISingleSortBoxItemModel[] | void) => {
          if (singleItems && singleItems.length) {
            singleItems = SharedFunctions.mergeItems("boxID", singleItems);
          }
          dispatch(setRxSingleItems(singleItems as ISingleSortBoxItemModel[]));
        })
        .finally(() => {});

      done();
    }
  },
});

const cancelSortBoxLogic = createLogic({
  type: CANCEL_RX_SORT_BOX,
  async process(
    {
      getState,
    }: {
      getState: any;
    },
    dispatch,
    done
  ) {
    const { rxSortBox, sortBoxModel, rxOrderSku, singleItemList } = getState()
      .rxModeReducer as IRxBoxAppState;
    const { operatorID } = getState().loginInfoReducer;
    if (singleItemList) {
      singleItemList.filter((x) => x.boxID === rxSortBox).forEach((x) => (x.wasCancelled = true));
      dispatch(setRxSingleItems(singleItemList));
    }
    dispatch(setRxCancelledOrderSku(new PayloadWrapper(rxOrderSku)));
    dispatch(setRxVerifyOperator(new PayloadWrapper(false)));
    if (sortBoxModel?.sortType === 1 || sortBoxModel?.shelfNumber === 51) {
      setStateWaitingForShelfScan(dispatch, ActionStates.SCAN_SINGLE_ARTICLE);
    } else {
      setStateWaitingForShelfScan(dispatch, ActionStates.SCAN_SHELF_OR_CART);
    }
    dispatch(setShowLoader(new PayloadWrapper(true)));
    IPackEndpoints.cancelSortBox(rxSortBox, [], false, operatorID, true, true)
      .then((res) => {
        dispatch(pollForRxNextSortBox());
      })
      .catch((error) => {
        dispatch(
          setError({
            message: "Lyckades inte avbryta fack",
            visible: true,
            errorType: -1,
          })
        );
        console.error(error);
      })
      .finally(() => {
        dispatch(setShowLoader(new PayloadWrapper(false)));
        done();
      });
  },
});

const fetchOrderCommentsLogic = createLogic({
  type: FETCH_ORDER_COMMENTS_FOR_RX_ORDER,
  async process(
    {
      getState,
    }: {
      getState: any;
    },
    dispatch,
    done
  ) {
    const { orderNumber, orderComments, rxSortBox } = getState().rxModeReducer as IRxBoxAppState;
    var rxSortBoxOld = rxSortBox;
    await RxEndpoints.fetchOrderComments(orderNumber, (error) => {
      //handle error
    }).then((orderCommentsNew: IRxComment[]) => {
      if (orderCommentsNew) {
        const { rxSortBox } = getState().rxModeReducer as IRxBoxAppState;
        if (rxSortBoxOld === rxSortBox) {
          orderCommentsNew.forEach((x, _) => {
            const oldMatchingComment = orderComments?.filter((z: IRxComment, _) => z.id === x.id);
            x.message = setLimaAbsoluteURLInComment(x);
            x.created = new Date(x.created);
            x.visible =
              oldMatchingComment && oldMatchingComment.length > 0
                ? oldMatchingComment[0].visible
                : true;
          });
          dispatch(setRxOrderComments(sortOrderCommentsByDateDescending(orderCommentsNew)));
        }
        dispatch(setLoadingStatus(new PayloadWrapper(false)));
      }
    });

    done();
  },
});

const fetchWarningMessagesLogic = createLogic({
  type: FETCH_WARNING_MESSAGES_FOR_RX_ORDER,
  async process(
    {
      getState,
    }: {
      getState: any;
    },
    dispatch,
    done
  ) {
    const { rxOrderSku } = getState().rxModeReducer as IRxBoxAppState;
    await RxEndpoints.fetchWarningMessages(rxOrderSku, (error) => {
      //handle error
    }).then((warningMessages: string[]) => {
      if (warningMessages) {
        dispatch(setRxWarningMessages(new PayloadWrapper(warningMessages)));
        dispatch(setLoadingStatus(new PayloadWrapper(false)));
      }
    });

    done();
  },
});

const fetchRxOperatorInstructionLogic = createLogic({
  type: FETCH_RX_OPERATOR_INSTRUCTION,
  async process(
    {
      getState,
    }: {
      getState: any;
    },
    dispatch,
    done
  ) {
    const { workstationID } = getState().loginInfoReducer;
    await OperatorEndpoints.getWorkstationInstruction(workstationID).then(
      (instruction: IOperatorInstructionModel) => {
        if (instruction && instruction.desiredCartId > -1) {
          dispatch(setRxInstruction(instruction));
        }
      }
    );
    done();
  },
});

const getRxAssistantOperatorLogic = createLogic({
  type: GET_RX_ASSISTING_OPERATOR,
  async process(_, dispatch, done) {
    dispatch(setLoadingStatus(new PayloadWrapper(true)));
    await RxEndpoints.getRxAssistantOperator((error) => {
      dispatch(
        setError({
          message: "Lyckades inte hämta assisterande operatör",
          visible: true,
          errorType: -1,
        })
      );
      console.error(error);
    })
      .then((assistantTasks: any[]) => {
        if (assistantTasks && assistantTasks.length > 0) {
          let assistantRxOperators = [] as IRxAssistantOperator[];
          for (let assistantTask of assistantTasks) {
            let assistantRxOperator: IRxAssistantOperator = {
              assistingOperatorID: assistantTask.assistingOperatorId,
              assistingMode: assistantTask.task,
              assistingOperatorName: assistantTask.assistingOperatorName,
            };
            assistantRxOperators.push(assistantRxOperator);
          }
          dispatch(setRxAssistingOperatorState(new PayloadWrapper(assistantRxOperators)));
        }
      })
      .finally(() => {
        dispatch(setLoadingStatus(new PayloadWrapper(false)));
      });

    done();
  },
});

const setRxAssistantOperatorLogic = createLogic({
  type: SET_RX_ASSISTING_OPERATOR,
  async process(
    {
      getState,
      action,
    }: {
      getState: any;
      action: StandardAction<string, IRxAssistantOperator>;
    },
    dispatch,
    done
  ) {
    const { assistingOperators } = getState().rxModeReducer as IRxBoxAppState;
    dispatch(setLoadingStatus(new PayloadWrapper(true)));
    await RxEndpoints.setRxAssistantOperator(action.payload, (error) => {
      dispatch(
        setError({
          message: "Lyckades inte sätta assisterande operatör",
          visible: true,
          errorType: -1,
        })
      );
      console.error(error);
    })
      .then((rxOperatorAssistantName: string) => {
        if (rxOperatorAssistantName) {
          action.payload.assistingOperatorName = rxOperatorAssistantName;
          assistingOperators.push(action.payload);
          dispatch(setRxAssistingOperatorState(new PayloadWrapper(assistingOperators)));
        }
      })
      .finally(() => {
        dispatch(setLoadingStatus(new PayloadWrapper(false)));
      });

    done();
  },
});

const clearRxAssistantOperatorLogic = createLogic({
  type: CLEAR_RX_ASSISTING_OPERATOR,
  async process(
    {
      getState,
      action,
    }: {
      getState: any;
      action: StandardAction<string, IPayloadWrapper<number>>;
    },
    dispatch,
    done
  ) {
    const { assistingOperators } = getState().rxModeReducer as IRxBoxAppState;
    dispatch(setLoadingStatus(new PayloadWrapper(true)));
    await RxEndpoints.clearRxAssistantOperator(action.payload.value, (error) => {
      dispatch(
        setError({
          message: "Lyckades inte sätta assisterande operatör",
          visible: true,
          errorType: -1,
        })
      );
      console.error(error);
    })
      .then(() => {
        let assistingOperatorsNew = assistingOperators.filter(
          (x) => x.assistingOperatorID !== action.payload.value
        );
        dispatch(setRxAssistingOperatorState(new PayloadWrapper(assistingOperatorsNew)));
      })
      .finally(() => {
        dispatch(setLoadingStatus(new PayloadWrapper(false)));
      });

    done();
  },
});

const setWarehouseAlarmLogic = createLogic({
  type: SET_WAREHOUSE_ALARM,
  async process(
    {      
      getState
    }: { 
      getState: any
     },
    dispatch,
    done) 
    {
      const loginState: LoginState = getState().loginInfoReducer;
      dispatch(setLoadingStatus(new PayloadWrapper(true)));

      await rxWestEndpoints.setWarehouseAlarm(loginState.workstationID).finally(() => {   
        dispatch(setLoadingStatus(new PayloadWrapper(false)));
    });
    done();
  },
});

function sortOrderCommentsByDateDescending(orderComments: IRxComment[]): IRxComment[] {
  return orderComments.sort((a, b) => (a.created <= b.created ? 1 : -1));
}

function sortboxItemsByNameAsc(sortBoxItems: ISortBoxItemModel[]): ISortBoxItemModel[] {
  return sortBoxItems.sort((a, b) => (a.name > b.name ? 1 : -1));
}

function setLimaAbsoluteURLInComment(comment: IRxComment): string {
  return comment.message.replace("<a href='/", "<a href='https://la.site.se/");
}

async function performSkuPutaway(
  getState: () => any,
  dispatch: <T extends ArgumentAction>(action: T) => T,
  done: () => void,
  shelfNumber: string,
  missingQuantity: number
) {
  const rxState: IRxBoxAppState = getState().rxModeReducer;
  const orderInfo: IOrderInfo | null = rxState.orderInfo;
  if (
    orderInfo?.SkuPutawayRequired === true &&
    rxState.skuPutawayBoxID &&
    rxState.skuPutawayBoxItem
  ) {
    dispatch(setLoadingStatus(new PayloadWrapper(true)));
    const { sortBoxModel } = rxState;
    if (sortBoxModel == null) return;
    let boxItem = rxState.skuPutawayBoxItem;
    let reviewBox = { ...sortBoxModel, missingBoxItem: null };
    //perform stock transfer
    await SortBoxEndpoints.putawayStock(
      boxItem.boxID,
      boxItem.shelfNumber,
      boxItem.isRxItem,
      missingQuantity,
      boxItem.skuID,
      shelfNumber,
      sortBoxModel.skuPutawaySupplierDeliveryId,
      true
    )
      .then((response) => {
        var sortboxModelItem = reviewBox.sortBoxItems.filter(
          (x) =>
            x.boxID == boxItem.boxID &&
            x.skuID == boxItem.skuID &&
            x.shelfNumber == boxItem.shelfNumber &&
            x.isRxItem == boxItem.isRxItem
        )[0];
        if (missingQuantity == 0) sortboxModelItem.verifiedQuantity = boxItem.reservedQuantity;
        else sortboxModelItem.reservedQuantity -= missingQuantity;
        reviewBox.skuPutawaySupplierDeliveryId = response.supplierDeliveryId;
        let remainingItems = reviewBox.sortBoxItems.filter(
          (x) => x.verifiedQuantity < x.reservedQuantity && x.reservedQuantity > 0
        );
        if (missingQuantity == 0) {
          dispatch(
            setRxInstructionMessage(
              new PayloadWrapper("Placera produkten i lagerback: " + response.shelfNumber)
            )
          );
        }
        if (remainingItems.length == 0) {
          reviewBox.sortBoxItems = [];
        }
        dispatch(setRxMissingAmountDialogSortBoxItem(new PayloadWrapper(null)));
        dispatch(setSkuPutawayBoxItem(new PayloadWrapper(null)));
        dispatch(setSkuPutawayErrorMessage(new PayloadWrapper(null)));
        dispatch(setSkuPutawayBinShelfNumber(new PayloadWrapper(null)));
        dispatch(setRxBoxModel(new PayloadWrapper(reviewBox)));
      })
      .catch((e) => {
        dispatch(setSkuPutawayBinShelfNumber(new PayloadWrapper(null)));
        dispatch(
          setSkuPutawayErrorMessage(
            new PayloadWrapper("Kunde inte genomföra lagerflytt: " + e.exceptionMessage)
          )
        );
      })
      .finally(() => {
        dispatch(setLoadingStatus(new PayloadWrapper(false)));
        done();
      });
  } else {
    done();
  }
}

export {
  pollForRxOrderLogic,
  fetchRxBoxLogic,
  fetchOrderCommentsLogic,
  pollForRxNextSortBoxLogic,
  cancelSortBoxLogic,
  setRxAssistantOperatorLogic,
  clearRxAssistantOperatorLogic,
  getRxAssistantOperatorLogic,
  fetchWarningMessagesLogic,
  fetchRxSingleItemsLogic,
  fetchRxOperatorInstructionLogic,
  rxSignalRMessageReceiverLogic,
  sendSortBoxSnoozed,
  sendScannedIPackBoxbarcodeLogic,
  setOrderInfoLogic,
  fetchFullOrderLogic,
  sendLoginInfoLogic,
  sendStationPausedLogic,
  sendBoxCancellation,
  setTimeStampLogic,
  sendPrintRXBodIDLogic,
  sendMaxxOrderFinishedLogic,
  getTeamleaderAvailabilityLogic,
  sendFlushQueueRequest,
  performSkuPutawayLogic,
  performSkuPutawayMissingLogic,
  setRxAutoOrderDoneLogic,
  boxNotificationLogic,
  setWarehouseAlarmLogic,
};
